import { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'
import styled from 'styled-components'
import { Token } from '@revolut-internal/ui-kit'

import { urlTransform } from './urlTransform'
import { renderMarkdownAnchor } from './renderMarkdownAnchor'

const MarkdownStyled = styled(ReactMarkdown)`
  white-space: pre-wrap;

  p {
    margin: 0;
  }

  ul,
  ol,
  li {
    line-height: normal;
    margin: 0 0 0 ${Token.space.s16};
    padding: 0;
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: numeric;
  }

  hr {
    border: none;
    background-color: ${Token.color.greyTone5};
    height: 1px;
  }
`

type Props = {
  chatUiRenderMethod?: boolean
  children?: unknown
}

export const Markdown: FC<Props> = props => {
  const { chatUiRenderMethod = false, children } = props

  if (!children || typeof children !== 'string') {
    return null
  }

  return (
    <MarkdownStyled
      allowedElements={
        chatUiRenderMethod
          ? ['a', 'code', 'strong', 'em', 'ul', 'li']
          : ['a', 'code', 'strong', 'em', 'ul', 'li', 'ol', 'p', 'hr']
      }
      unwrapDisallowed
      remarkPlugins={[remarkBreaks, remarkGfm]}
      transformLinkUri={urlTransform}
      components={{
        a: renderMarkdownAnchor,
      }}
    >
      {chatUiRenderMethod ? children.replace(/\n/gi, '\n &nbsp;') : children}
    </MarkdownStyled>
  )
}
